var map = {
	"./_fallbackIcon.svg": 553,
	"./add-card-hover.svg": 554,
	"./add-card.svg": 555,
	"./add-photo.svg": 556,
	"./an-home-building.svg": 557,
	"./an-interaction.svg": 558,
	"./an-people-group.svg": 559,
	"./an-people-peer.svg": 560,
	"./an-school-building.svg": 561,
	"./an-teacher-instruct.svg": 562,
	"./an-teachers-feedback.svg": 563,
	"./an_laptop.svg": 564,
	"./angle-double-left.svg": 565,
	"./angle-double-right.svg": 566,
	"./angle-down.svg": 567,
	"./angle-up.svg": 568,
	"./apps.svg": 569,
	"./archive.svg": 570,
	"./arrow-alt.svg": 571,
	"./arrow-angle-collapse.svg": 572,
	"./arrow-angle-down.svg": 573,
	"./arrow-angle-expand.svg": 574,
	"./arrow-angle-left.svg": 575,
	"./arrow-angle-right.svg": 576,
	"./arrow-angle-up-down.svg": 577,
	"./arrow-angle-up.svg": 578,
	"./arrow-backward.svg": 579,
	"./arrow-carvet-down.svg": 580,
	"./arrow-carvet-left.svg": 581,
	"./arrow-carvet-right.svg": 582,
	"./arrow-carvet-up-down-ascending.svg": 583,
	"./arrow-carvet-up-down-descending.svg": 584,
	"./arrow-carvet-up-down-inactive.svg": 585,
	"./arrow-carvet-up-down.svg": 586,
	"./arrow-carvet-up.svg": 587,
	"./arrow-diangonal-right.svg": 588,
	"./arrow-down.svg": 589,
	"./arrow-enter.svg": 590,
	"./arrow-external-link.svg": 591,
	"./arrow-forward.svg": 592,
	"./arrow-inward.svg": 593,
	"./arrow-left.svg": 594,
	"./arrow-outward.svg": 595,
	"./arrow-right-left.svg": 596,
	"./arrow-right.svg": 597,
	"./arrow-sync.svg": 598,
	"./arrow-up-down.svg": 599,
	"./arrow-up.svg": 600,
	"./assignment-material.svg": 601,
	"./assignment-question.svg": 602,
	"./assignment.svg": 603,
	"./attachment.svg": 604,
	"./backpack.svg": 605,
	"./bell-gradient-dark.svg": 606,
	"./bell-gradient-light.svg": 607,
	"./bell-gradient.svg": 608,
	"./bell.svg": 609,
	"./bomb.svg": 610,
	"./book-open.svg": 611,
	"./book.svg": 612,
	"./bookmark.svg": 613,
	"./books-stack.svg": 614,
	"./bubble- box-speech.svg": 615,
	"./bubble-blank.svg": 616,
	"./bubble-box-speech.svg": 617,
	"./bubble-speech.svg": 618,
	"./calendar.svg": 619,
	"./camera.svg": 620,
	"./caret-down.svg": 621,
	"./caret-right.svg": 622,
	"./chain.svg": 623,
	"./check-sm.svg": 624,
	"./check.svg": 625,
	"./checkerboard.svg": 626,
	"./checklist-gradient-white.svg": 627,
	"./checklist-gradient.svg": 628,
	"./checklist.svg": 629,
	"./chevron-down.svg": 630,
	"./chevron-left.svg": 631,
	"./chevron-right.svg": 632,
	"./circle-arrow-left.svg": 633,
	"./circle-arrow-right.svg": 634,
	"./circle-blackboard-gray.svg": 635,
	"./circle-blackboard-green.svg": 636,
	"./circle-blackboard.svg": 637,
	"./circle-book.svg": 638,
	"./circle-check-fill.svg": 639,
	"./circle-checklist.svg": 640,
	"./circle-checkmark.svg": 641,
	"./circle-cross.svg": 642,
	"./circle-empty.svg": 643,
	"./circle-exclamation-orange.svg": 644,
	"./circle-exclamation-red.svg": 645,
	"./circle-exclamation.svg": 646,
	"./circle-google-drive-logo.svg": 647,
	"./circle-graduate-cap-gray.svg": 648,
	"./circle-graduate-cap.svg": 649,
	"./circle-information.svg": 650,
	"./circle-labels-gray.svg": 651,
	"./circle-labels.svg": 652,
	"./circle-minus.svg": 653,
	"./circle-misc.svg": 654,
	"./circle-people-gray.svg": 655,
	"./circle-people.svg": 656,
	"./circle-person-gray.svg": 657,
	"./circle-person.svg": 658,
	"./circle-plus.svg": 659,
	"./circle-profile-gray-exclamation.svg": 660,
	"./circle-profile-gray.svg": 661,
	"./circle-question.svg": 662,
	"./circle-stack.svg": 663,
	"./circle-stacked-checkmark-gray.svg": 664,
	"./circle-stacked-checkmark.svg": 665,
	"./circle-stacked-ribbon-filled-gray.svg": 666,
	"./circle-stacked-ribbon-filled.svg": 667,
	"./circle-stacked-ribbon-gray.svg": 668,
	"./circle-stacked-ribbon.svg": 669,
	"./circle-star-gray.svg": 670,
	"./circle-star.svg": 671,
	"./circle-zipped-file-gray.svg": 672,
	"./circle-zipped-file.svg": 673,
	"./classes.svg": 674,
	"./clipboard.svg": 675,
	"./clock-history.svg": 676,
	"./clock.svg": 677,
	"./close.svg": 678,
	"./code.svg": 679,
	"./coding.svg": 680,
	"./cog-fill-gradient-white.svg": 681,
	"./cog-fill.svg": 682,
	"./cog.svg": 683,
	"./cogs.svg": 684,
	"./collection.svg": 685,
	"./comment-o.svg": 686,
	"./connection-no.svg": 687,
	"./copy-link.svg": 688,
	"./copy.svg": 689,
	"./create-drive.svg": 690,
	"./cross-sm.svg": 691,
	"./cross.svg": 692,
	"./cube.svg": 693,
	"./delete.svg": 694,
	"./description.svg": 695,
	"./diamond.svg": 696,
	"./dots.svg": 697,
	"./drive-coloured.svg": 698,
	"./drive.svg": 699,
	"./dropdown-button.svg": 700,
	"./duplicate.svg": 701,
	"./edit-cog.svg": 702,
	"./edit.svg": 703,
	"./editor.svg": 704,
	"./edublogs-icon.svg": 705,
	"./ellipsis-h.svg": 706,
	"./ellipsis.svg": 707,
	"./emoji-books-stack.svg": 708,
	"./emoji-books.svg": 709,
	"./emoji-nerdface.svg": 710,
	"./emoji-open-book.svg": 711,
	"./emoji-partypopper.svg": 712,
	"./emoji-pen.svg": 713,
	"./emoji-raisinghands.svg": 714,
	"./emoji-school-bag.svg": 715,
	"./emoji-sparkles.svg": 716,
	"./emoji-teacher.svg": 717,
	"./emoji-telescope.svg": 718,
	"./emoji-victoryhand.svg": 719,
	"./emoji-writinghand.svg": 720,
	"./envelope-o.svg": 721,
	"./envelope.svg": 722,
	"./exclamation-circle.svg": 723,
	"./exclamation-triangle.svg": 724,
	"./exclamation.svg": 725,
	"./expand.svg": 726,
	"./eye-closed.svg": 727,
	"./eye.svg": 728,
	"./file-add.svg": 729,
	"./file-copy.svg": 730,
	"./file-download-cloud.svg": 731,
	"./file-download.svg": 732,
	"./file-upload-cloud.svg": 733,
	"./file-upload.svg": 734,
	"./file.svg": 735,
	"./fill-circle-exclamation.svg": 736,
	"./fill-circle-question.svg": 737,
	"./fill-envelope.svg": 738,
	"./fill-focused-browsing.svg": 739,
	"./filter-funnel.svg": 740,
	"./filter-lines.svg": 741,
	"./filter.svg": 742,
	"./fire.svg": 743,
	"./flag-fill.svg": 744,
	"./flag.svg": 745,
	"./focus-shield.svg": 746,
	"./focus.svg": 747,
	"./focused-browsing-on.svg": 748,
	"./folder.svg": 749,
	"./frown-o.svg": 750,
	"./globe.svg": 751,
	"./google-classroom-round.svg": 752,
	"./google-classroom-square.svg": 753,
	"./google-classroom.svg": 754,
	"./google-data-studio.svg": 755,
	"./google-document.svg": 756,
	"./google-drawing.svg": 757,
	"./google-drive.svg": 758,
	"./google-folder.svg": 759,
	"./google-form.svg": 760,
	"./google-gmail.svg": 761,
	"./google-image.svg": 762,
	"./google-jam.svg": 763,
	"./google-logo-drive.svg": 764,
	"./google-map.svg": 765,
	"./google-pdf.svg": 766,
	"./google-plus.svg": 767,
	"./google-presentation.svg": 768,
	"./google-sheet.svg": 769,
	"./google-site.svg": 770,
	"./google-slides.svg": 771,
	"./google-spreadsheet.svg": 772,
	"./group.svg": 773,
	"./hamburger.svg": 774,
	"./hand-holding-pen.svg": 775,
	"./heart.svg": 776,
	"./home.svg": 777,
	"./icon-filter.svg": 778,
	"./icon-flag-australia.svg": 779,
	"./icon-flag-canada.svg": 780,
	"./icon-flag-new-zealand.svg": 781,
	"./icon-flag-usa.svg": 782,
	"./icon_card.svg": 783,
	"./icon_group.svg": 784,
	"./icon_workspace.svg": 785,
	"./label-filled.svg": 786,
	"./label.svg": 787,
	"./lightbulb-o.svg": 788,
	"./link.svg": 789,
	"./list-arrow-animated.svg": 790,
	"./list-arrow.svg": 791,
	"./list-checkmark.svg": 792,
	"./loader-light.svg": 793,
	"./loader.svg": 794,
	"./lock-fill.svg": 795,
	"./lock.svg": 796,
	"./login-logo-google.svg": 797,
	"./logo-hapara-small-black.svg": 798,
	"./logo-hapara-small-light.svg": 799,
	"./logo-hapara-small.svg": 800,
	"./magnifying-glass-plus.svg": 801,
	"./mail-reply.svg": 802,
	"./map-pin.svg": 803,
	"./material-icon-folder.svg": 804,
	"./members-gradient-white.svg": 805,
	"./members-gradient.svg": 806,
	"./message-text-fill.svg": 807,
	"./message-text.svg": 808,
	"./minus-sm.svg": 809,
	"./minus.svg": 810,
	"./modal-close.svg": 811,
	"./modules.svg": 812,
	"./multiple-devices.svg": 813,
	"./multiple-logins.svg": 814,
	"./open-book.svg": 815,
	"./paperdoll-fill-partial.svg": 816,
	"./paperdoll-fill.svg": 817,
	"./paperdoll-outline.svg": 818,
	"./pencil-alt.svg": 819,
	"./pencil-fill.svg": 820,
	"./pencil.svg": 821,
	"./plus-circle.svg": 822,
	"./plus-sm.svg": 823,
	"./plus-thick.svg": 824,
	"./plus.svg": 825,
	"./power-off.svg": 826,
	"./printer.svg": 827,
	"./profile-group-filled.svg": 828,
	"./profile-group-gradient-white.svg": 829,
	"./profile-group-gradient.svg": 830,
	"./profile-group.svg": 831,
	"./profile-solo.svg": 832,
	"./pushpin.svg": 833,
	"./question-circle-o.svg": 834,
	"./question.svg": 835,
	"./record.svg": 836,
	"./recording.svg": 837,
	"./refresh.svg": 838,
	"./remove.svg": 839,
	"./return-final.svg": 840,
	"./return-for-edit.svg": 841,
	"./rocket.svg": 842,
	"./school-bag.svg": 843,
	"./screen-pause.svg": 844,
	"./sd-arrow-angle-left-white.svg": 845,
	"./sd-arrow-angle-left.svg": 846,
	"./sd-arrow-angle-right-white.svg": 847,
	"./sd-arrow-angle-right.svg": 848,
	"./sd-arrow-carvet-down.svg": 849,
	"./sd-arrow-carvet-up.svg": 850,
	"./sd-calendar-outline.svg": 851,
	"./sd-cross.svg": 852,
	"./sd-filterAll.svg": 853,
	"./sd-folder-fill-white.svg": 854,
	"./sd-folder-fill.svg": 855,
	"./sd-folder-outline.svg": 856,
	"./sd-graphic-notebook.svg": 857,
	"./sd-layout-arrow.svg": 858,
	"./sd-speech-box-fill-white.svg": 859,
	"./sd-speech-box-fill.svg": 860,
	"./sd-speech-box-outline.svg": 861,
	"./sd-workbook-fill-white.svg": 862,
	"./sd-workbook-fill.svg": 863,
	"./sd-workbook-outline.svg": 864,
	"./search.svg": 865,
	"./share.svg": 866,
	"./sharing.svg": 867,
	"./single-device.svg": 868,
	"./sitemap.svg": 869,
	"./smiley-face.svg": 870,
	"./sort-asc.svg": 871,
	"./sort-desc.svg": 872,
	"./spinner.svg": 873,
	"./stack.svg": 874,
	"./star-fill.svg": 875,
	"./star.svg": 876,
	"./startable.svg": 877,
	"./started.svg": 878,
	"./student-group-add.svg": 879,
	"./student-group-confirm-delete-alert.svg": 880,
	"./student-groups-collapse.svg": 881,
	"./student-groups-expand.svg": 882,
	"./student-selector-added-teacher-alert.svg": 883,
	"./student-selector-search-clear.svg": 884,
	"./student-selector-search.svg": 885,
	"./submitted.svg": 886,
	"./tag.svg": 887,
	"./teacher.svg": 888,
	"./trash-o.svg": 889,
	"./trash.svg": 890,
	"./twitter.svg": 891,
	"./unlock.svg": 892,
	"./unshare.svg": 893,
	"./upload.svg": 894,
	"./video-play.svg": 895,
	"./workspace-icon-gradient-white.svg": 896,
	"./workspace-icon-gradient.svg": 897,
	"./workspace-icon.svg": 898,
	"./ws-thumbnail-default-square.svg": 899,
	"./youtube.svg": 900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 552;